/**
 * The service catalog shown on the calculator landing page. `id` doubles as
 * the route segment under /config/services/ and as the `serviceId` stored on
 * every estimate line.
 */
export const services = [
  {
    id: "compute",
    name: "Compute",
    category: "Compute",
    keywords: ["instance", "vm", "server", "dd1", "dd2", "gpu", "cvm", "ec2"],
    description:
      "Compute provides a wide selection of instance types optimized to fit different use cases. Instance types comprise varying combinations of CPU, memory, storage and networking capacity, including confidential computing (SEV-SNP) instances, GPU instances and dedicated hosts.",
  },
  {
    id: "databases",
    name: "Databases",
    category: "Databases",
    keywords: [
      "postgres",
      "postgresql",
      "mysql",
      "redis",
      "opensearch",
      "elasticsearch",
      "cache",
      "search",
    ],
    description:
      "Fully managed database services: PostgreSQL/MySQL with automated backups, Redis for in-memory caching, and OpenSearch for search and analytics workloads. We handle patching, backups and monitoring so you can focus on your data.",
  },
  {
    id: "storage",
    name: "Storage",
    category: "Storage",
    keywords: [
      "s3",
      "object",
      "backup",
      "lto",
      "archive",
      "block",
      "volume",
      "registry",
      "efs",
      "file system",
    ],
    description:
      "Our Storage Services provide S3 object storage, backup storage, long-term LTO archival, block storage volumes, container registry storage and elastic file systems. Whether you need fast access, secure backups or long-term archival, our storage solutions are designed for efficient and cost-effective data management.",
  },
  {
    id: "network",
    name: "Network",
    category: "Networking",
    keywords: [
      "ip",
      "traffic",
      "vpn",
      "load balancer",
      "waf",
      "nat",
      "ddos",
      "private connect",
      "bandwidth",
    ],
    description:
      "Our Network Services ensure seamless, secure and cost-effective connectivity across cloud environments. We offer IP management, traffic routing, secure VPN solutions, load balancing, web application firewalling, NAT gateways, DDoS protection and dedicated private connections.",
  },
  {
    id: "managed-services",
    name: "Managed Services",
    category: "Management & Governance",
    keywords: [
      "maintenance",
      "rancher",
      "kubernetes",
      "iam",
      "identity",
      "dns",
      "email",
      "support",
    ],
    description:
      "Our Managed Services provide end-to-end solutions for maintaining, securing and optimizing your cloud infrastructure: VM maintenance, security advisory, Rancher cluster management, managed identity (IAM), anycast DNS, transactional email and support plans.",
  },
  {
    id: "software",
    name: "Software",
    category: "Developer Tools",
    keywords: ["gitlab", "ci", "cd", "version control"],
    description:
      "Software Services provide enterprise-grade solutions to streamline your development, collaboration and deployment processes, including managed GitLab for version control and CI/CD automation. Choose from different plans tailored to your business needs.",
  },
];

/** Old bookmarks and stored lines still refer to the section as "ec2". */
export const SERVICE_ALIASES = {
  ec2: "compute",
};

export const findService = (id) =>
  services.find(
    (service) => service.id === (SERVICE_ALIASES[id] || id)
  );
